import { render, staticRenderFns } from "./ModalAnexos.vue?vue&type=template&id=a657cd84&scoped=true&lang=pug&"
import script from "./ModalAnexos.vue?vue&type=script&lang=js&"
export * from "./ModalAnexos.vue?vue&type=script&lang=js&"
import style0 from "./ModalAnexos.vue?vue&type=style&index=0&id=a657cd84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a657cd84",
  null
  
)

export default component.exports